import styled, { css } from 'styled-components';
import * as React from 'react';

import { Timestamp } from 'components/common';
import { relativeDifferenceDays } from 'util/DateTime';

const Container = styled.div`
  display: flex;
  gap: 15px;
`;

const DaysCol = styled.div(
  ({ theme }) => `
  font-size: ${theme.fonts.size.huge};
  line-height: 1;
`,
);

const DateAndTitleCol = styled.div`
  display: flex;
  flex-direction: column;
`;

const Date = styled.div`
  font-weight: bold;
`;

const Description = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
  `,
);

type Props = {
  date: string;
  description: string;
};

const DateStat = ({ date, description }: Props) => {
  const daysDifference = relativeDifferenceDays(date);

  return (
    <Container>
      <DaysCol>{daysDifference}</DaysCol>
      <DateAndTitleCol>
        <Date>
          <Timestamp dateTime={date} format="date" />
        </Date>
        <Description>{description}</Description>
      </DateAndTitleCol>
    </Container>
  );
};

export default DateStat;
